/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme } from "office-ui-fabric-react/lib/Styling";
import styled from "styled-components";

import { FontSizes, FontWeights, IMessageBarStyles, IStackStyles } from "@fluentui/react";

const theme = getTheme();

/**
 * Message Bar Error Styles.
 */
export const errorStyles: IMessageBarStyles = {
  root: {
    marginBottom: "0.5rem",
    marginTop: "0.5rem",
  },
};

/**
 * Styling for container wrapping inner detail contents (i.e. user's access control)
 */
export const DetailWrapper = styled.div`
  padding: 10px;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
`;

export const listStyles = (): IStackStyles => {
  return {
    root: {
      backgroundColor: theme.palette.white,
    },
  };
};

export const innerStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "1rem",
      paddingTop: "0.5rem",
    },
  };
};
